import { ReactNode, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Cookies from 'universal-cookie';

import { AngularRouter } from './AngularRouter';

const FORCE_PARAM = 'force';
const COOKIE = 'us-migration-ui';
const FORCE_REACT_VALUES = ['family', 'caregiver'] as const;

const cookies = new Cookies();

interface Props {
  angularPath: string;
  children: ReactNode;
}

// Per-route gate. Default forwards to the still-live Angular page so the
// migration ships with zero user-visible change. The new React port renders
// when the request carries the existing `?force=family` / `?force=caregiver`
// override (the same param HAProxy uses to route the request here in the first
// place) — or when this session has already done so once. The choice is stored
// in `us-migration-ui` so client-side navigations within React stay in React
// without re-appending `?force=` on every link.
export const MigrationGate = ({ angularPath, children }: Props): JSX.Element => {
  const [searchParams] = useSearchParams();
  const forceValue = searchParams.get(FORCE_PARAM);
  const isReactForce =
    !!forceValue && (FORCE_REACT_VALUES as readonly string[]).includes(forceValue);

  useEffect(() => {
    if (isReactForce) {
      cookies.set(COOKIE, 'react', { path: '/' });
    }
  }, [isReactForce]);

  const cookieValue = cookies.get(COOKIE) as string | undefined;
  const showReact = isReactForce || cookieValue === 'react';

  if (showReact) return <>{children}</>;
  return <AngularRouter path={angularPath} />;
};
